exports.components = {
  "component---src-pages-404-tsx": () => import("./../../../src/pages/404.tsx" /* webpackChunkName: "component---src-pages-404-tsx" */),
  "component---src-templates-entity-template-tsx": () => import("./../../../src/templates/EntityTemplate.tsx" /* webpackChunkName: "component---src-templates-entity-template-tsx" */),
  "component---src-templates-legal-template-tsx": () => import("./../../../src/templates/LegalTemplate.tsx" /* webpackChunkName: "component---src-templates-legal-template-tsx" */)
}

